<template>
  <div class="threeFloor">
    <div class="empty" v-if="!currComponent">
      <img src="/static/picture/record-blank.png" alt="" />
    </div>
    <div class="ProcessDetail" v-else>
      <el-scrollbar ref="processScrollBar" v-scrollbar-height="16" class="formBox" v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading">
        <component :is="currComponent" :ID="templateInfo.ID" :TemplateID="templateInfo.TemplateID" :type="type" @refresh="refresh" @loading="load" />
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import BidFollowProcessDetail from '../processDetail/BidFollowProcessDetail.vue';
import ArchivesProcessDetail from '../processDetail/ArchivesProcessDetail.vue';
import CustomerProcessDetail from '../processDetail/CustomerProcessDetail.vue';
import JobLogProcessDetail from '../processDetail/JobLogProcessDetail.vue';
import ChannelCommission from '../processDetail/ChannelCommission.vue';
import Reimbursement from '../processDetail/Reimbursement.vue';
import OutsideCommissionPerson from '../processDetail/OutsideCommissionPerson.vue';
import SubstitutePaymentRefund from '../processDetail/SubstitutePaymentRefund.vue';
import ChannelCodeDetail from '../processDetail/ChannelCodeDetail.vue';
export default {
  name: 'threeFloor',
  props: ['templateInfo', 'type'],
  components: { ChannelCodeDetail, BidFollowProcessDetail, ArchivesProcessDetail, CustomerProcessDetail, JobLogProcessDetail, ChannelCommission, Reimbursement, OutsideCommissionPerson, SubstitutePaymentRefund },
  data() {
    return {
      loading: false,
      currComponent: '',
    };
  },
  watch: {
    templateInfo: {
      handler(val, oldVal) {
        switch (val.TemplateID) {
          case 3:
            this.currComponent = 'ArchivesProcessDetail'; // 归档资料申请流程
            break;
          case 4:
            this.currComponent = 'CustomerProcessDetail'; // 合作客户流程
            break;
          case 5:
            this.currComponent = 'CustomerProcessDetail'; // 重点客户流程
            break;
          case 6:
            this.currComponent = 'JobLogProcessDetail'; // 日志流程
            break;
          // case 7:
          //   this.currComponent = '' // 延长客户保护期
          //   break
          case 8:
            this.currComponent = 'BidFollowProcessDetail'; // 中标项目跟进流程
            break;
          case 9:
            this.currComponent = 'ChannelCommission'; // 渠道提成申请
            break;
          case 13:
            this.currComponent = 'Reimbursement'; // 报销申请
            break;
          case 14:
            this.currComponent = 'OutsideCommissionPerson'; // 外部提成人申请 & 负责人折扣
            break;
          case 15:
            this.currComponent = 'SubstitutePaymentRefund'; // 投标渠道成本和代垫退款申请
            break;
          case 16:
            this.currComponent = 'OutsideCommissionPerson'; // 外部提成人申请 & 负责人折扣
            break;
          case 17:
            this.currComponent = 'ChannelCodeDetail'; //渠道邀请码审批流程
            break;
          default:
            break;
        }
      },
      deep: true,
      immediate: true,
    },
    type() {
      this.currComponent = '';
    },
  },
  beforeUpdate() {
    //   滚动条滚动到0
    if (this.currComponent && this.$refs.processScrollBar) {
      this.$refs.processScrollBar.wrap.scrollTop = 0;
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
      this.currComponent = '';
    },
    load(val) {
      this.loading = val;
    },
  },
};
</script>
<style scoped lang="less">
.threeFloor {
  flex: 1;
  height: 100%;
  min-width: 1276px;
  background: #ffffff;
  padding: 16px 24px 16px 24px;
  .empty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 400px;
      margin: 100px auto;
    }
  }
}
</style>
